import React from "react";

type Props = {
  onStartDrawing: () => void;
  onTakePicture: () => void;
  onOpenPhoto: () => void;
};

export const BlankSpace: React.FC<Props> = ({
  onStartDrawing,
  onTakePicture,
  onOpenPhoto,
}) => {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "grid",
        placeItems: "center",
        background: "linear-gradient(180deg, #fdfdfd 0%, #f5faff 100%)", // soft light gradient
        pointerEvents: "auto",
      }}
    >
      <style>{`
        @keyframes bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-8px); }
        }
        .big-btn {
          transition: transform 150ms ease;
        }
        .big-btn:active { transform: scale(0.95); }
      `}</style>

      <div style={{ display: "grid", gap: 32, justifyItems: "center" }}>
        {/* PRIMARY big Start button */}
        <button
          onClick={onStartDrawing}
          className="big-btn"
          aria-label="Start drawing"
          style={{
            width: 200,
            height: 200,
            borderRadius: "50%",
            border: "none",
            cursor: "pointer",
            background: "linear-gradient(135deg, #ffb347, #ffcc33)", // cheerful yellow/orange
            boxShadow: "0 6px 16px rgba(0,0,0,0.15)",
            display: "grid",
            placeItems: "center",
            animation: "bounce 2s infinite",
          }}
        >
          {/* Gallery/start icon */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="88"
            height="88"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-label="Open gallery"
          >
            <rect x="3" y="3" width="18" height="18" rx="2" />
            <circle cx="9" cy="9" r="1.4" />
            <path d="M7 17l3.2-3.6a1 1 0 0 1 1.4 0L14 17l3-4 3 4H7z" />
          </svg>
        </button>
        <div style={{ fontSize: 18, fontWeight: 600, color: "#444" }}>
          Start
        </div>

        {/* SECONDARY smaller buttons */}
        <div
          style={{
            display: "grid",
            gridAutoFlow: "column",
            gap: 40,
            justifyContent: "center",
          }}
        >
          {/* Camera */}
          <div style={{ textAlign: "center" }}>
            <button
              onClick={onTakePicture}
              style={{
                width: 96,
                height: 96,
                borderRadius: "50%",
                border: "none",
                cursor: "pointer",
                background: "linear-gradient(135deg, #6dd5fa, #2980b9)", // sky blue
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                color: "#fff",
                display: "grid",
                placeItems: "center",
              }}
            >
              <svg width="40" height="40" viewBox="0 0 24 24" fill="white">
                <path d="M20 5h-3.17l-1.84-2H8.99L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14H4V7h4.05l1.83-2h4.24l1.83 2H20v12z" />
                <circle cx="12" cy="13" r="3.5" />
              </svg>
            </button>
            <div style={{ marginTop: 8, fontSize: 14, color: "#444" }}>
              Camera
            </div>
          </div>

          {/* Open Photo */}
          <div style={{ textAlign: "center" }}>
            <button
              onClick={onOpenPhoto}
              style={{
                width: 96,
                height: 96,
                borderRadius: "50%",
                border: "none",
                cursor: "pointer",
                background: "linear-gradient(135deg, #a8ff78, #78ffd6)", // green/mint
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                color: "#fff",
                display: "grid",
                placeItems: "center",
              }}
            >
              <svg width="40" height="40" viewBox="0 0 24 24" fill="white">
                <path d="M10 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2zM4 18V6h5.17l2 2H20v10H4z" />
              </svg>
            </button>
            <div style={{ marginTop: 8, fontSize: 14, color: "#444" }}>
              Photos
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
